





















import { Component, Vue, Mixins } from 'vue-property-decorator';
import InquiryListItem from '@/components/inquiry/InquiryListItem.vue';
import { inquiryService } from '@/services/InquiryService';
import {
  ScopedListInquiries_inquiries,
  OperatorFields,
  ScopedListInquiries,
  CustomerFields
} from '@/types/graphql/schemaTypes';
import Pagination from '@/mixins/pagination';
import ShipmentNavBar from '@/components/layout/NavBar.vue';
import Filters from '@/components/layout/Filters.vue';
import ScopedListInquiriesQuery from '@/graphql/queries/ScopedListInquiries.gql';
import { InquiryFilterType } from '@/types/types';
import { ApolloQueryResult } from 'apollo-client';

@Component({
  components: {
    Filters,
    'nav-bar': ShipmentNavBar,
    'inquiry-item': InquiryListItem
  },
  apollo: {
    inquiries: {
      query: ScopedListInquiriesQuery,
      prefetch: true,
      variables() {
        const query = this.$route.query;
        const operatorId = query?.operatorId !== 'all' ? query?.operatorId : null;

        const inquiryArgs = {
          operatorId,
          cargo: query.cargo || null,
          customerOrganizationId: query.customerOrganizationId || null,
          pod: query.pod || null,
          pol: query.pol || null,
          priority: parseInt(query.priority, 10) || null,
          reference: query.reference || null,
          status: query.status || null,
          tradeDirection: query.tradeDirection || null
        };

        return {
          inquiryArgs,
          pagination: {
            page: parseInt(this.$route.query.page, 10) || this.currentPage,
            per: parseInt(this.$route.query.size, 10) || this.paginationSize
          }
        };
      },
      skip() {
        return !this.filtersReady;
      },
      update(data) {
        this.totalCount = data ? data.inquiriesPagination.totalCount : 0;
        return data && data.inquiries;
      },
      fetchPolicy: 'cache-and-network'
    }
  }
})
export default class InquiryList extends Mixins(Pagination) {
  public inquiries: ScopedListInquiries_inquiries[] = [];
  private filtersReady = false;

  public fetchInquiries() {
    this.$apollo.queries.inquiries.refetch();
  }
}
